<template>
    <div v-if="content" v-editable="content" :style="backgroundInlineStyle">
        <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
    </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    backgroundInlineStyle: function() {
      let background = ''
      let backgroundCover = ''
      if(this.content.background_image) {
        background += 'url('+this.content.background_image.filename +') '
      }
      if(this.content.background_color) {
        background += this.content.background_color.color
      }
      if(this.content.background_cover) {
        backgroundCover += 'background-size: cover;'
      }

      if(background === '') {
        return null
      } else {
        return 'background:'+background+';'+backgroundCover
      }
    },
  },
  methods: {
    async fetchData() {
        try {
            const res = await api.get(`cdn/stories/${this.$i18n.locale}/pages/${this.$route.params.slug}`);
            this.content = res.data.story.content;

            document.title = `${this.content.title} - City Aventure`;
        } catch (err) {
            this.$router.push("/404");
        }
    }
  }
};
</script>